import { useParams } from 'react-router-dom';

import UsersOverview from '../../features/users/layouts/overview';
import UserDetail from '../../features/users/layouts/detail';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
// /admin/users · /admin/users/:id  (alta/edición/rol viven en modales del feature).

export default function UsersPage() {
    const { id } = useParams();
    if (id) return <UserDetail userId={id} />;
    return <UsersOverview />;
}
